import HomeSkeletonLayout from '~/domains/home/components/HomeSkeleton';

import type { HomeCollectionSlug } from '../../constants/query';
import { usePromotedContestsCollection } from '../../hooks/usePromotedContestsCollection';
import { CondensedCarouselModule } from '../CondensedCarouselModule/CondensedCarouselModule';

import { useStyles } from './CondensedCarouselCollection.styles';

type CondensedCarouselCollectionProps = {
  slug: HomeCollectionSlug;
  order?: number;
};

export function CondensedCarouselCollection({ slug, order }: CondensedCarouselCollectionProps) {
  const { classes } = useStyles({ order });
  const { carousels, isLoading } = usePromotedContestsCollection(slug);

  if (isLoading) {
    return <HomeSkeletonLayout isLoading order={order ?? 0} />;
  }

  if (carousels.length === 0) {
    return null;
  }

  return (
    <div className={classes.collection}>
      {carousels.map((carousel) => (
        <CondensedCarouselModule key={carousel.id} slug={slug} carousel={carousel} />
      ))}
    </div>
  );
}
